import { render, staticRenderFns } from "./ZoneNavButton.vue?vue&type=template&id=6a5a0cbe&scoped=true&"
import script from "./ZoneNavButton.vue?vue&type=script&lang=ts&"
export * from "./ZoneNavButton.vue?vue&type=script&lang=ts&"
import style0 from "./ZoneNavButton.vue?vue&type=style&index=0&id=6a5a0cbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5a0cbe",
  null
  
)

export default component.exports